import React from 'react';
import { useTranslation } from 'react-i18next';

function RotateMessage()
{
  const { t } = useTranslation();
  return(
    <div id="landscape_disabled-message">
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="100" fillRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" clipRule="evenodd" viewBox="0 0 417 419">
                <path fill="white" d="M285.914 43.584c57.531 26.151 97.629 81.939 104.602 148.187h26.151C406.206 83.682 317.294 0 207.462 0h-12.204l66.248 66.248 24.408-22.664ZM176.081 29.637c-10.46-10.46-26.151-10.46-36.611 0L27.894 141.213c-10.46 10.461-10.46 26.151 0 36.611l209.205 209.205c10.46 10.461 26.151 10.461 36.611 0l111.576-111.576c10.46-10.46 10.46-26.15 0-36.611L176.081 29.637Zm80.195 339.959L47.071 160.391 158.647 48.815 367.852 258.02 256.276 369.596Zm-127.266 5.23c-57.532-26.151-97.629-81.939-104.603-148.187H0C8.717 334.728 97.629 418.41 207.462 418.41h12.203l-66.248-66.248-24.407 22.664Z"/>
            </svg>
            <h3>{t("common.game.rotate_message")}</h3>
        </div>
    </div>
  )
}

export default RotateMessage;